import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import MemberDocs from '../Components/MemberDocs'
import { Member } from '../Hooks/useMembers'
import { Page } from './Page'

const Docs: React.FC = () => {
  const location = useLocation()
  const [member, setMember] = useState<Member | undefined>(location.state?.data)
  const navigate = useNavigate()

  useEffect(() => {
    if (member == undefined) {
      navigate('/search')
    }
  }, [location])
  return (
    <Page title="Docs">
      <div>
        <MemberDocs member={member} />
      </div>
    </Page>
  )
}

export default Docs
